import { FC } from 'react'
import { Spinner } from 'react-bootstrap'
import { Controller, useFormContext } from 'react-hook-form'
import { IKlantGroepModel } from 'shared/models/IKlantGroepModel'
import { VasModel } from 'shared/models/Vas/VasModel'

interface IProps {
  vasModelList: VasModel[]
  isLoading: boolean
}

const VasCodeCodeControl: FC<IProps> = ({ vasModelList, isLoading }) => {
  const { control, setValue } = useFormContext<IKlantGroepModel>()

  return (
    <Controller
      name='vasCode.code'
      control={control}
      render={({ field }) => (
        <>
          <select
            {...field}
            value={field.value || ''}
            style={{ width: '90%' }}
            disabled={isLoading}
            onChange={e => {
              field.onChange(e)

              if (e.target.value === '') {
                setValue('verrekenIndicatie', 'N')
              } else {
                setValue('verrekenIndicatie', 'J')
              }
            }}
          >
            <option value='' />
            {vasModelList.map(vm => (
              <option key={vm.vasCode} value={vm.vasCode}>
                {vm.vasCode} / {vm.vasDescription}
              </option>
            ))}
          </select>
          {isLoading && (
            <Spinner animation='border' size='sm' className='ml-2' />
          )}
        </>
      )}
    />
  )
}

export default VasCodeCodeControl
